var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from 'vue-property-decorator';
import WarehousingApply from '~/components/apply-component/warehousing-apply.vue';
import { namespace } from "vuex-class";
import { MENU_CHANNEL } from "~/config/enum.config";
import { CarManageService } from '~/services/domain-service/car-manage.service';
import { Dependencies } from "~/core/decorator";
var CollectionExecutionModule = namespace("collection-execution");
var WarehousingApplicationButton = /** @class */ (function (_super) {
    __extends(WarehousingApplicationButton, _super);
    function WarehousingApplicationButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.applyType = {};
        return _this;
    }
    Object.defineProperty(WarehousingApplicationButton.prototype, "fromChannel", {
        get: function () {
            var telChannel = [MENU_CHANNEL.Tel_team, MENU_CHANNEL.Tel_personal];
            var visitChannel = [MENU_CHANNEL.Visit_personal, MENU_CHANNEL.Visit_team];
            var legalChannel = [MENU_CHANNEL.Legal_personal, MENU_CHANNEL.Legal_team];
            if (telChannel.includes(this.menuChannel))
                return 'TEL';
            else if (visitChannel.includes(this.menuChannel))
                return 'VISIT';
            else if (legalChannel.includes(this.menuChannel))
                return 'LEGAL';
            else
                return '';
        },
        enumerable: false,
        configurable: true
    });
    WarehousingApplicationButton.prototype.onClickButton = function () {
        var _this = this;
        this.carManageService.getWarehouseCarByCaseInfoRecordId(this.caseId).subscribe(function (data) {
            if (!data || (data && data === 'IN_WAREHOUSE_REJECT'))
                _this.dialog = true;
            else
                _this.$message.error('该案件的车辆状态不符合条件，无法做入库申请！');
        });
    };
    __decorate([
        Dependencies(CarManageService)
    ], WarehousingApplicationButton.prototype, "carManageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], WarehousingApplicationButton.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], WarehousingApplicationButton.prototype, "menuChannel", void 0);
    __decorate([
        Prop()
    ], WarehousingApplicationButton.prototype, "carFrameNo", void 0);
    WarehousingApplicationButton = __decorate([
        Component({
            components: {
                WarehousingApply: WarehousingApply
            }
        })
    ], WarehousingApplicationButton);
    return WarehousingApplicationButton;
}(Vue));
export default WarehousingApplicationButton;
